import React, { FC } from 'react';

import {
  Container,
  Product,
  Category,
  Row,
  Number,
  Name,
  Prize,
  SectionTitle,
  Instruction,
  Quantity,
  Modifier,
  PrizeModifiers,
  Separator,
  Subtotal,
  Taxes,
  Discount,
  Total,
  PleaseLabel,
  Label,
  Group,
} from './styles';
import { Props } from './types';

const Summary: FC<Props> = ({ order }) => {
  return (
    <Container>
      {order.items.map((product) => (
        <Product key={`${product.name}`}>
          <Category>{product.category}</Category>
          <Row>
            <Number>{product.quantity}</Number>
            <Group>
              <Name>{product.name}</Name>{' '}
              {order.type.isGroup && product.label && (
                <>
                  <PleaseLabel>Please label</PleaseLabel>
                  <Label>{product.label}</Label>
                </>
              )}
            </Group>
            <Prize>{product.price}</Prize>
          </Row>
          {product.note && (
            <>
              <SectionTitle>Special instructions</SectionTitle>
              <Instruction>{product.note}</Instruction>
            </>
          )}
          {product.modifiers && <SectionTitle>Modifiers</SectionTitle>}
          {product.modifiers &&
            product.modifiers.map((modifier) => (
              <Row key={modifier.name}>
                <Quantity>{modifier.quantity}</Quantity>
                <Modifier>{modifier.name}</Modifier>
                <PrizeModifiers>{modifier.price}</PrizeModifiers>
              </Row>
            ))}
        </Product>
      ))}

      {order.notes.order && (
        <>
          <Separator />
          <SectionTitle>Order instructions</SectionTitle>
          <Instruction>{order.notes.order}</Instruction>
        </>
      )}

      <Separator />
      <Subtotal>
        <span>Subtotal</span>
        <span>{order.payment.subtotal}</span>
      </Subtotal>
      <Taxes>
        <span>Taxes</span>
        <span>{order.payment.tax}</span>
      </Taxes>
      <Discount>
        <span>Discount</span>
        <span>{order.payment.discount}</span>
      </Discount>
      <Total>
        <span>Total</span>
        <span>{order.payment.total}</span>
      </Total>
    </Container>
  );
};

export default Summary;
